// Central route-path registry. Modules reference these constants instead of
// hard-coding path strings, so a path change is a single edit here.
//
// Seed set only — add each feature's paths here as you build its module, then
// register that module's route records in `privateRoutes.ts` / `publicRoutes.ts`.
export const routes = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  LISTINGS: '/listings',
  LISTING_NEW: '/listings/new',
  LISTING_AGREEMENT_SIGN_RETURN: '/listings/agreements/sign-return',
  LISTING_DETAIL: '/listings/:id',
  // Properties the seller's approved requests were promoted into (read-only —
  // there is no create path, promotion is admin-driven).
  PROPERTIES: '/properties',
  PROPERTY_DETAIL: '/properties/:id',
  // Public (no-login) owner signing via a secure emailed/shared link.
  PUBLIC_AGREEMENT_SIGN: '/agreements/sign/:token',
  PUBLIC_AGREEMENT_SIGN_RETURN: '/agreements/sign/:token/return',
  // Public (no-login) property-owner onboarding. admin-service mails this exact
  // path — changing it breaks links already sitting in owners' inboxes.
  PUBLIC_OWNER_ONBOARDING: '/owners/onboarding/:token',
  ERROR: '/error',
  NOTFOUND: '/not-found',
} as const
